import React from 'react';
import './sidemenu.css';

interface SideMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const SideMenu: React.FC<SideMenuProps> = ({ isOpen, onClose }) => {
  console.log('SideMenu render - isOpen:', isOpen);
  
  const menuItems = [
    { label: 'SummerDeals', href: '/summerdeals', delay: '0.05s' },
    { label: 'Home', href: '/', delay: '0.1s' },
    { label: 'Web Design', href: '/servicii/web-design', delay: '0.15s' },
    { label: 'E-commerce', href: '/servicii/e-commerce', delay: '0.2s' },
    { label: 'Branding', href: '/servicii/branding', delay: '0.25s' },
    { label: 'Online Marketing', href: '/servicii/online-marketing', delay: '0.3s' },
    { label: 'ServerSide Tracking', href: '/servicii/serverside-tracking', delay: '0.35s' },
    { label: 'Portfoliu', href: '/portfoliu', delay: '0.4s' },
    { label: 'Contact', href: '/contact', delay: '0.45s' }
  ];

  const handleItemClick = (href: string) => {
    if (href.startsWith('http')) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      window.location.assign(href);
    }
    onClose();
  };

  return (
    <>
      {/* Backdrop - only show when open */}
      {isOpen && <div className="menu-backdrop-new" onClick={onClose} />}
      
      {/* Slide-in Menu Panel - always rendered for animations */}
      <div className={`side-menu-new ${isOpen ? 'side-menu-open' : ''}`}>
        {/* Clean Header */}
        <div className="menu-header">
          <h2 className="menu-title">Navigation</h2>
        </div>

        {/* Menu Items */}
        <nav className="menu-nav">
          {menuItems.map((item) => (
            <div 
              key={item.label}
              className="menu-item-new"
              style={{ 
                animationDelay: isOpen ? item.delay : '0s',
                transitionDelay: isOpen ? item.delay : '0s'
              }}
              onClick={() => handleItemClick(item.href)}
            >
              <span className="item-text">{item.label}</span>
              <div className="item-underline"></div>
            </div>
          ))}
        </nav>

        {/* Footer accent */}
        <div className="menu-footer">
          <div className="accent-line"></div>
          <p className="footer-text">Pixado • Pixel Perfect</p>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
